<script setup lang="ts">
import { ref } from 'vue';
import BackstageInputLabel from './BackstageInputLabel.vue';

interface Props {
  label?: string;
  modelValue?: string;
}

withDefaults(defineProps<Props>(), {
  label: '',
  modelValue: '',
});

const emit = defineEmits<{
  change: [];
  'update:modelValue': [value: string | number];
}>();

const inputFocused = ref(false);
const textarea = ref<HTMLInputElement | null>(null);

// methods
function focusOnInput() {
  inputFocused.value = true;
  textarea.value?.focus();
}

function removeInputFocus() {
  inputFocused.value = false;
  emit('change');
}

function updateValue(event: Event) {
  emit('update:modelValue', (event.target as HTMLInputElement).value);
}
</script>
<template>
  <BackstageInputLabel :label="label" v-on:focus="focusOnInput" v-on:click="focusOnInput">
    <textarea
      ref="textarea"
      :value="modelValue"
      v-bind="$attrs"
      v-on:blur="removeInputFocus"
      v-on:focus="focusOnInput"
      v-on:input="updateValue">
      <slot></slot>
    </textarea>
  </BackstageInputLabel>
</template>

<style lang="scss" scoped>
.field-new:deep() {
  .input-container {
    flex: 1;

    textarea {
      width: 100%;
      height: 100%;
      max-height: auto;
    }
  }
}
</style>
